(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/utils.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const log = new svs.core.log.Logger('components:TicketUtility');
const minimumHeightDefault = 320;
const cache = {};
const trackTopBarAction = svs.ticketgames.ticketUtility.utils.tracking.trackTopBarAction;
const WIN_ONE_TICKET = svs.bubble_win_message.extraIcon.WIN_ONE_TICKET;
const getSurroundingElementsHeights = () => {
  var _document$querySelect, _document$querySelect2;
  const menuContent = document.querySelector('.js-top-content');
  return {
    topBarHeight: ((_document$querySelect = document.querySelector('.gamelauncher-topbar')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight) || 48,
    menuHeight: svs.core.detect.breakpoint.greaterThan('md') ? menuContent.getBoundingClientRect().height : 0,
    accountBalanceBarHeight: ((_document$querySelect2 = document.querySelector('.account-balance-bar')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.offsetHeight) || 0
  };
};
const utils = {
  showTrissNextLobby: () => svs.tickets.data.templateConfig.showTrissNextLobby,
  normalizeSkinId: skinIdParam => {
    const isNumber = new RegExp(/^[0-9]\d*$/).test(skinIdParam);
    if (isNumber) {
      return parseInt(skinIdParam, 10);
    }
    return 1;
  },
  normalizeWin: result => {
    var _result$prize, _result$data;
    const amount = result.wonAmount.value / 100;
    const prizeType = ((_result$prize = result.prize) === null || _result$prize === void 0 ? void 0 : _result$prize.type) || ((_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.eventReference) === null || _result$data === void 0 ? void 0 : _result$data.prizeType);
    return {
      extraicon: prizeType,
      amount,
      game: {},
      winFlag: amount > 0 || Boolean(prizeType)
    };
  },
  executeSpecialWinAction: (gameResult, onDone) => {
    if ((gameResult === null || gameResult === void 0 ? void 0 : gameResult.extraicon) === WIN_ONE_TICKET) {
      log.info('Executing special win action: WIN_ONE_TICKET');
      const game = svs.ticketgames.gameHandler.getPackageGame();
      svs.ticketgames.ticketUtility.payTicket({
        ticket: {
          price: game.price,
          type: game.type,
          name: game.name,
          themeName: game.packageGameConfig.theme.themeName,
          skinId: game.packageGameConfig.skinId
        },
        shouldConfirmPayment: false,
        onDone: _ref => {
          let successfulTickets = _ref.successfulTickets,
            failedTickets = _ref.failedTickets;
          if (successfulTickets.length > 0) {
            log.info('Successfully purchased ticket:', successfulTickets[0]);
            onDone === null || onDone === void 0 || onDone({
              action: gameResult === null || gameResult === void 0 ? void 0 : gameResult.extraicon,
              wonTicket: successfulTickets[0]
            });
          }
          if (failedTickets.length > 0) {
            log.error('Failed to purchase ticket:', failedTickets);
            onDone === null || onDone === void 0 || onDone({
              action: gameResult === null || gameResult === void 0 ? void 0 : gameResult.extraicon,
              error: new Error('Failed to purchase ticket')
            });
          }
        }
      });
      return {
        action: gameResult === null || gameResult === void 0 ? void 0 : gameResult.extraicon,
        shouldNotUseStandardContinueFlow: true
      };
    }
    return {};
  },
  getAccountBalanceAsync: () => new Promise(resolve => {
    svs.components.account_balance.get(true, balance => {
      resolve(balance);
    });
  }),
  getAccountBalanceAfterChange: _ref2 => {
    let next = _ref2.next;
    const onBalanceChange = balance => {
      svs.components.account_balance.off('change', onBalanceChange);
      next({
        latestAccountBalance: svs.utils.format.CurrencyFromJupiterString(balance)
      });
    };
    svs.components.account_balance.on('change', onBalanceChange);
  },
  resizeFromFullscreen: (container, ticketInfo) => {
    if (!container) {
      return {};
    }
    const minHeight = ticketInfo.minHeight;
    const _getSurroundingElemen = getSurroundingElementsHeights(),
      topBarHeight = _getSurroundingElemen.topBarHeight,
      accountBalanceBarHeight = _getSurroundingElemen.accountBalanceBarHeight,
      menuHeight = _getSurroundingElemen.menuHeight;
    const topContentHeight = topBarHeight + accountBalanceBarHeight + menuHeight;
    const minimumHeight = parseInt(minHeight, 10) || minimumHeightDefault;
    const height = window.innerHeight - topContentHeight;
    if (minimumHeight >= height) {
      container.style.height = "".concat(minimumHeight, "px");
      container.style.width = "100%";
      return {
        isMinHeight: true
      };
    }
    container.style.height = "".concat(height, "px");
    container.style.width = "".concat(innerWidth, "px");
    return {
      isMinHeight: false
    };
  },
  resizeFromTicketInfo: (container, ticketInfo) => {
    const _getSurroundingElemen2 = getSurroundingElementsHeights(),
      topBarHeight = _getSurroundingElemen2.topBarHeight,
      menuHeight = _getSurroundingElemen2.menuHeight;
    const height = ticketInfo.height,
      width = ticketInfo.width,
      containHeight = ticketInfo.containHeight,
      margin = ticketInfo.margin;
    const setSize = (height, width) => {
      container.style.height = "".concat(height, "px");
      container.style.width = "".concat(width, "px");
    };
    const _window = window,
      innerWidth = _window.innerWidth,
      innerHeight = _window.innerHeight;
    const aspectRatio = height / width; 
    const screenAspectRatio = innerHeight / innerWidth; 

    if (containHeight && containHeight > innerHeight && aspectRatio > screenAspectRatio) {
      const newHeight = innerHeight - menuHeight - margin * 2;
      const newWidth = newHeight / aspectRatio;
      setSize(newHeight + topBarHeight, newWidth);
    }
    const newWidth = Math.min(innerWidth - margin * 2, width);
    const newHeight = newWidth * aspectRatio;
    setSize(newHeight, newWidth);
    return {
      height: newHeight + topBarHeight,
      width: newWidth
    };
  },
  getVoucherCode: async voucherCode => {
    const voucherId = voucherCode === null || voucherCode === void 0 ? void 0 : voucherCode.toUpperCase();
    const _await$svs$tur$apiCal = await svs.tur.apiCaller.ticketgames.getVoucherById({
        voucherId
      }),
      response = _await$svs$tur$apiCal.response;
    if (response.state !== 'ACTIVE') {
      throw new Error('inactive voucherCode');
    }
    return response;
  },
  fetchGuides: async ticketInfo => {
    if (!ticketInfo.gameGuide.guides.length) {
      return [];
    }
    if (cache[ticketInfo.type]) {
      return cache[ticketInfo.type];
    }
    const articles = ticketInfo.gameGuide.guides.filter(guide => guide.article);
    if (!articles.length) {
      return [];
    }
    const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-tb');
    try {
      let responses;
      if (useLegacyJupiterApi) {
        responses = await Promise.all(articles.map(async (guide, index) => {
          try {
            var _data$response, _data$response2;
            const url = new svs.content.shared.ContentUrlBuilder("/id/".concat(guide.article)).build();
            const data = await svs.core.jupiter.callAsync({
              method: 'GET',
              path: url
            });
            if (data !== null && data !== void 0 && (_data$response = data.response) !== null && _data$response !== void 0 && _data$response.error) {
              log.error('Error fetching article', data.response.error);
              return null;
            }
            if (!(data !== null && data !== void 0 && (_data$response2 = data.response) !== null && _data$response2 !== void 0 && _data$response2.result) || data.response.result.length === 0) {
              log.error('Spelguide article not found', data.response);
              return null;
            }
            return _objectSpread({
              tabName: guide.tabName,
              active: index === 0,
              order: index
            }, data.response.result[0]);
          } catch (error) {
            log.error('Error fetching guide:', error);
            return null;
          }
        }));
      } else {
        const client = svs.content.shared.getCmsClient();
        responses = await Promise.all(articles.map(async (guide, index) => {
          try {
            const response = await client.v1.content.getByIds({
              ids: guide.article
            });
            if (!(response !== null && response !== void 0 && response.result) || response.result.length === 0) {
              log.error('Spelguide article not found (CMS API)', response);
              return null;
            }
            return _objectSpread({
              tabName: guide.tabName,
              active: index === 0,
              order: index
            }, response.result[0]);
          } catch (error) {
            log.error('Error fetching guide (CMS API):', error);
            return null;
          }
        }));
      }
      const spelGuidesList = responses.filter(guide => guide !== null);

      if (spelGuidesList.length > 0) {
        cache[ticketInfo.type] = spelGuidesList;
      }
      return spelGuidesList;
    } catch (error) {
      log.error('Error fetching guides:', error);
      return [];
    }
  },
  showDialog: _ref3 => {
    let type = _ref3.type,
      _ref3$isDemo = _ref3.isDemo,
      isDemo = _ref3$isDemo === void 0 ? false : _ref3$isDemo,
      onClose = _ref3.onClose,
      trackingData = _ref3.trackingData;
    const dialogTexts = {
      close: {
        icon: 'help-2',
        title: 'Vill du avsluta spelet?',
        message: {
          text: isDemo ? ' ' : 'Du hittar dina köpta lotter i Mina spel'
        },
        actions: {
          cancel: {
            title: 'AVBRYT',
            callback: e => {
              e.preventDefault();
              trackTopBarAction('Avbryt', trackingData === null || trackingData === void 0 ? void 0 : trackingData.label, trackingData === null || trackingData === void 0 ? void 0 : trackingData.value);
            }
          },
          action: {
            title: 'AVSLUTA SPEL',
            callback: e => {
              e.preventDefault();
              trackTopBarAction('Avsluta spel', trackingData === null || trackingData === void 0 ? void 0 : trackingData.label, trackingData === null || trackingData === void 0 ? void 0 : trackingData.value);
              onClose(e);
            }
          }
        }
      },
      selfTest: {
        icon: 'self-test',
        title: 'Vill du göra ett självtest?',
        message: {
          text: "Du l\xE4mnar spelet om du g\xF6r ett sj\xE4lvtest. ".concat(isDemo ? '' : 'Du hittar köpta lotter i Mina spel.')
        },
        actions: {
          cancel: {
            title: 'AVBRYT'
          },
          action: {
            title: 'GÖR SJÄLVTEST',
            callback: e => {
              e.preventDefault();
              if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
                window.location.href = svs.core.urlMapping.get('gamingResponsibilityHabits');
              } else {
                window.location.href = svs.core.urlMapping.get('gamingResponsibilitySelfTest');
              }
            }
          }
        }
      }
    };
    const dialogSettings = dialogTexts[type];
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      icon: dialogSettings.icon,
      area: svs.components.dialog.area.POPUP,
      title: dialogSettings.title,
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: dialogSettings.message.text
      }],
      actions: [{
        title: dialogSettings.actions.cancel.title,
        callback: e => {
          var _dialogSettings$actio, _dialogSettings$actio2;
          (_dialogSettings$actio = (_dialogSettings$actio2 = dialogSettings.actions.cancel).callback) === null || _dialogSettings$actio === void 0 || _dialogSettings$actio.call(_dialogSettings$actio2, e);
          dialog.close();
        }
      }, {
        title: dialogSettings.actions.action.title,
        callback: e => {
          dialogSettings.actions.action.callback(e);
          dialog.close();
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  },
  showGameClosedDialog: _ref4 => {
    let isDemo = _ref4.isDemo,
      onClose = _ref4.onClose,
      gameCode = _ref4.gameCode;
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      type: svs.ui.dialog.type.ERROR,
      area: svs.components.dialog.area.POPUP,
      title: 'Denna lott är inte tillgänglig för köp',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: isDemo ? ' ' : 'Du hittar dina köpta lotter i Mina spel.'
      }],
      actions: [{
        title: 'Okej',
        callback: () => {
          dialog.close();
          onClose();
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
    log.info("game closed dialog shown for gameCode: ".concat(gameCode));
  },
  showWonTicketWaitingDialog: function () {
    let _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onClose = _ref5.onClose;
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      icon: 'win',
      area: svs.components.dialog.area.POPUP,
      title: 'Din Triss finns i Mina spel',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Din vinst, en Triss värd 30 kr, ligger nu och väntar på dig i Mina spel. ' + 'Har du fått flera presentlotter kan du skrapa klart dem först. När du är färdig kan du skrapa din vinstlott direkt från Mina spel.'
      }, {
        type: svs.components.dialog.message.TEXT,
        text: 'Du har sju dagar på dig att skrapa vinstlotten innan den autorättas.'
      }],
      actions: [{
        title: 'Okej',
        callback: e => {
          dialog.close();
          onClose === null || onClose === void 0 || onClose(e);
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  },
  showScratchLaterDialog: function () {
    let _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onClose = _ref6.onClose;
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      icon: 'thumbs-up',
      area: svs.components.dialog.area.POPUP,
      title: 'Härligt att dra ut på spänningen!',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Nu ligger din Triss och väntar på dig i Mina spel. Kom tillbaka och skrapa den inom sju dagar, annars rättas den automatiskt.'
      }, {
        type: svs.components.dialog.message.TEXT,
        text: 'Lycka till!'
      }],
      actions: [{
        title: 'Okej',
        callback: e => {
          dialog.close();
          onClose === null || onClose === void 0 || onClose(e);
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  },
  showWonTicketRedeemedDialog: function () {
    let _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onScratchNow = _ref7.onScratchNow,
      onScratchLater = _ref7.onScratchLater;
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      icon: 'thumbs-up',
      area: svs.components.dialog.area.POPUP,
      title: 'Kul att du vill skrapa digitalt!',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Du kan nu välja om du vill skrapa din Triss direkt eller om du vill dra ut på spänningen.'
      }, {
        type: svs.components.dialog.message.TEXT,
        text: 'Väljer du att vänta lite hittar du din Triss i Mina spel och kan skrapa när du själv vill. Du har sju dagar på dig, sedan autorättas lotten.'
      }],
      actions: [{
        title: 'Skrapa senare',
        callback: e => {
          dialog.close();
          onScratchLater === null || onScratchLater === void 0 || onScratchLater(e);
        }
      }, {
        title: 'Skrapa din Triss',
        callback: e => {
          dialog.close();
          onScratchNow === null || onScratchNow === void 0 || onScratchNow(e);
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  },
  showWonTicketUnredeemableDialog: function () {
    let _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onClose = _ref8.onClose;
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      type: svs.components.dialog.type.ERROR,
      area: svs.components.dialog.area.POPUP,
      title: 'Letar du efter din lott eller vinst?',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'I Mina spel hittar du all information om dina lotter och spel, så väl pågående som avslutade. Där finns även information om eventuella vinster eller förluster.'
      }, {
        type: svs.components.dialog.message.TEXT,
        text: 'Har du börjat skrapa en lott men inte avslutat den kan du fortsätta skrapa den i Mina spel. Om lotten inte skrapas inom sju dagar autorättas den.'
      }],
      actions: [{
        title: 'Okej',
        callback: e => {
          dialog.close();
          onClose === null || onClose === void 0 || onClose(e);
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  },
  showErrorDialog: _ref9 => {
    let title = _ref9.title,
      message = _ref9.message,
      onClose = _ref9.onClose;
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      type: svs.ui.dialog.type.ERROR,
      area: svs.components.dialog.area.POPUP,
      title,
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: message
      }],
      actions: [{
        title: 'Okej',
        callback: e => {
          dialog.close();
          onClose === null || onClose === void 0 || onClose(e);
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  },
  currencyFormatter: val => val / 100,
  constants: {
    leia: {
      GAME_LOADERS: {
        FGS_BRIDGE: 'FGS_BRIDGE',
        NEO_RGS: 'NEO'
      },
      gameEngineCode: {
        VEIKKAUS: 'EIN',
        FDJ: 'ITG',
        NEO: 'NEO'
      },
      lotteryChannel: {
        WEB: 'WEB',
        VOUCHER: 'VOUCHER'
      },
      gameConfig: {
        VEIKKAUS: {
          minimumHeight: minimumHeightDefault
        },
        default: {
          minimumHeight: minimumHeightDefault
        }
      },
      errors: {
        types: ['requestError', 'error'].map(e => e.toLowerCase()),
        events: ['createSession', 'getReplayProtectionToken', 'createITGBet', 'updateITGBet', 'claimITGBet', 'error'].map(e => e.toLowerCase())
      }
    }
  }
};
setGlobal('svs.ticketgames.ticketUtility.logger', log);
setGlobal('svs.ticketgames.ticketUtility.utils', utils);

 })(window);